import Home from "./Home";
import Career from "./Career";
import Contact from "./Contact";
import Gallery from "./Gallery";
import News from "./News";
import WhoWeAre from "./WhoWeAre";

export default [Home, Career, Contact, Gallery, News, WhoWeAre];
